/**
 * Constants for PostGrid functionality
 */

// Cheque amount limits
export const CHEQUE_MIN_AMOUNT = 0.01;
export const CHEQUE_MAX_AMOUNT = 300.0;

// Cheque amount validation messages
export const CHEQUE_AMOUNT_ERROR_MESSAGE = `Amount must be between $${CHEQUE_MIN_AMOUNT.toFixed(2)} and $${CHEQUE_MAX_AMOUNT.toFixed(2)}`;
